import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import { ErrorConstant, PLACE_HOLDER, SECTION_NAME } from '../../models';
import { DataLayerAnalyticsService } from '../../services/analytics/data-layer.service';
import { StatusTrackerService } from '../../services/api/status-tracker.service';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class TrackerEffects {
  loadTrackerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadTracker),
      switchMap(() =>
        combineLatest([
          this.overview.flags$.pipe(
            filter((flag) => !!flag?.overview.tracker),
            take(1)
          ),
          this.overview.serviceConfiguration$.pipe(
            filter((payload) => !!payload?.carrierCode),
            take(1)
          ),
          this.overview.aemErrorMessages$.pipe(
            filter((aemErrorMessages) => aemErrorMessages !== undefined),
            take(1)
          )
        ]).pipe(
          switchMap(([, payload, aemErrorMessages]) =>
            this.statusTracker.getStatusTrackerResponse(payload).pipe(
              filter((content) => !!content),
              switchMap((content) => {
                return of(
                  OverviewActions.loadTrackerSuccess({
                    tracker: {
                      id: 'status-tracker-content',
                      statusTrackerContent: content
                    }
                  })
                );
              }),
              catchError((error: HttpErrorResponse) => {
                const message = aemErrorMessages.find((item) => {
                  return item.component === 'tracker';
                });
                this.dataLayer.setErrorData(
                  error,
                  message.errorMessageDescription,
                  ErrorConstant.EVENT_NAME.replace(
                    PLACE_HOLDER,
                    SECTION_NAME.TRACKER
                  ),
                  ErrorConstant.TYPE.replace(PLACE_HOLDER, SECTION_NAME.TRACKER)
                );
                return of(
                  OverviewActions.loadTrackerFailure({
                    error: {
                      id: 'status-tracker-content-error',
                      statusTrackerContentError: 'tracker'
                    }
                  })
                );
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly statusTracker: StatusTrackerService,
    private readonly overview: OverviewFacade,
    protected dataLayer: DataLayerAnalyticsService
  ) {}
}
